export default {
  BELENUS: 'Belenus',
};